import { Particle } from "../particle";
import { colorGradient, easeOut, lerp, linearMotion, randomAngle, randomBetween } from "../interpolation";

/**
 * Hot orange/yellow flame jetting downward from the JetpackMob's back during
 * a ballistic jump. Direction-agnostic — the thrust always points down regardless
 * of the mob's facing or jump heading. Designed to leave a clearly visible trail
 * along the entire arc of a long jump.
 */
export class JetpackFlameParticle extends Particle {
	/** Emission interval for generators (ms between particles). Sparse, similar to missile exhaust. */
	static readonly emitIntervalMs = 35;

	constructor(originX: number, originY: number) {
		const ttl = randomBetween(350, 500);

		// Slight horizontal jitter so the trail isn't a single pixel-thin line
		const vx = randomBetween(-0.4, 0.4);
		// Downward thrust (positive y = down on screen).
		const vy = randomBetween(1.5, 2.8);

		const startSize = randomBetween(0.35, 0.5);
		const endSize = randomBetween(0.05, 0.12);

		// Spawn slightly below the mob's center so the flame visually emerges
		// from the jetpack nozzle area, not the mob's chest.
		const ox = originX + randomBetween(-0.15, 0.15);
		const oy = originY + randomBetween(0.1, 0.25);

		const startAngle = randomAngle();

		super(ox, oy, {
			ttl,
			size: lerp(startSize, endSize),
			opacity: easeOut(1.0, 0.0),
			color: colorGradient([
				{ r: 255, g: 220, b: 50 },
				{ r: 255, g: 120, b: 20 },
				{ r: 80, g: 80, b: 80 },
			]),
			rotation: lerp(startAngle, startAngle + 1.0),
			position: linearMotion(vx, vy),
		});
	}
}
